import React from 'react'
import { Button } from 'reactstrap'
import { Link } from 'react-router-dom'

export default function AddButton({children, id, role}) {
  return (
    <Link to={`/users/manage/${role}/add/${id ? id : ''}`}>
      <Button className="btn-rounded-15">{children}</Button>
    </Link>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/AddButton.js